var render = function () {
  var _vm$preorderSetting$t, _vm$preorder$preorder;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "PreorderSettingList",
      "extra-items": [{
        text: (_vm$preorderSetting$t = _vm.preorderSetting.title) !== null && _vm$preorderSetting$t !== void 0 ? _vm$preorderSetting$t : ''
      }, '預購單列表', {
        text: (_vm$preorder$preorder = _vm.preorder.preorder_number) !== null && _vm$preorder$preorder !== void 0 ? _vm$preorder$preorder : ''
      }]
    }
  })], 1)]), _c('b-card', [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('div', {
    staticClass: "row mb-3 align-items-center"
  }, [_c('div', {
    staticClass: "col-12 col-xl-2"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("預購單資料")])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('b-form-group', {
    attrs: {
      "disabled": _vm.readonly
    }
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "8",
      "label": "訂單編號(內部)",
      "disabled": ""
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.preorder.preorder_number,
      callback: function callback($$v) {
        _vm.$set(_vm.preorder, "preorder_number", $$v);
      },
      expression: "preorder.preorder_number"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "8",
      "label": "分店名稱 & ID",
      "disabled": ""
    }
  }, [_c('b-form-input', {
    attrs: {
      "value": _vm.preorder.branch ? _vm.preorder.branch.name + ' ' + _vm.preorder.branch.id : '無'
    }
  })], 1), _vm.preorder.customer ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "8",
      "label": "會員姓名",
      "disabled": ""
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.preorder.customer.name,
      callback: function callback($$v) {
        _vm.$set(_vm.preorder.customer, "name", $$v);
      },
      expression: "preorder.customer.name"
    }
  })], 1) : _vm._e(), _vm.preorder.customer ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "8",
      "label": "外部會員ID",
      "disabled": ""
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.preorder.customer.outer_code,
      callback: function callback($$v) {
        _vm.$set(_vm.preorder.customer, "outer_code", $$v);
      },
      expression: "preorder.customer.outer_code"
    }
  })], 1) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "8",
      "label": "訂單狀態",
      "disabled": _vm.checkPermission([_vm.consts.PREORDER_STATUS_MODIFY]) === false
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.statusOptions
    },
    model: {
      value: _vm.preorder.status,
      callback: function callback($$v) {
        _vm.$set(_vm.preorder, "status", $$v);
      },
      expression: "preorder.status"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "8",
      "label": "下單時間",
      "disabled": ""
    }
  }, [_c('b-form-input', {
    attrs: {
      "value": _vm.dateFormatter(_vm.preorder.created_at)
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "8",
      "label": "更新時間",
      "disabled": ""
    }
  }, [_c('b-form-input', {
    attrs: {
      "value": _vm.dateFormatter(_vm.preorder.updated_at)
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "8",
      "label": "預購單金額",
      "disabled": ""
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.preorder.total_amount,
      callback: function callback($$v) {
        _vm.$set(_vm.preorder, "total_amount", $$v);
      },
      expression: "preorder.total_amount"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "4",
      "label-size": "m",
      "content-cols": "12",
      "content-cols-lg": "8",
      "label": "點數總計",
      "disabled": ""
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.preorder.total_points,
      callback: function callback($$v) {
        _vm.$set(_vm.preorder, "total_points", $$v);
      },
      expression: "preorder.total_points"
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "col-4"
  }, [_c('b-form-group', {
    attrs: {
      "disabled": _vm.readonly
    }
  }, _vm._l(_vm.preorder.data, function (data, key) {
    return _c('b-form-group', {
      key: key,
      attrs: {
        "label-cols": "12",
        "label-cols-lg": "4",
        "label-size": "m",
        "content-cols": "12",
        "content-cols-lg": "8",
        "label": data.title,
        "disabled": ""
      }
    }, [_c('b-form-input', {
      model: {
        value: data.value,
        callback: function callback($$v) {
          _vm.$set(data, "value", $$v);
        },
        expression: "data.value"
      }
    })], 1);
  }), 1)], 1)]), _c('div', {
    staticClass: "row mt-4 align-items-center"
  }, [_c('div', {
    staticClass: "col-12 col-xl-2"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("訂單明細")])])]), !_vm.readonly ? _c('div', {
    staticClass: "text-right"
  }, [false ? _c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0 ml-2 py-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.addItemHandler
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("新增商品 ")]) : _vm._e()], 1) : _vm._e(), _c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "items": _vm.preorder.items,
      "fields": _vm.fields,
      "busy": _vm.showLoading
    },
    scopedSlots: _vm._u([{
      key: "cell(name)",
      fn: function fn(data) {
        return [_c('div', [_vm._v(" " + _vm._s(data.item.title) + " " + _vm._s(data.item.sku_outer_code) + " ")])];
      }
    }, {
      key: "cell(price)",
      fn: function fn(data) {
        return [_c('div', [_vm._v(" " + _vm._s(data.item.price) + " ")])];
      }
    }, {
      key: "cell(quantity)",
      fn: function fn(data) {
        return [_c('div', [_vm._v(" " + _vm._s(data.item.quantity) + " ")])];
      }
    }])
  }), _c('div', {
    staticClass: "d-flex justify-content-center",
    staticStyle: {
      "margin-top": "80px"
    }
  }, [_c('b-button', {
    staticClass: "mr-4",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [[_vm._v("返回")]], 2), _vm.checkPermission([_vm.consts.PREORDER_STATUS_MODIFY]) ? _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [[_vm._v("更新")]], 2) : _vm._e()], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }